module.exports = __webpack_public_path__ + "static/media/empty-data.b69a5ec6.svg";